export const boxShadow = '3px 2px 6px 0 rgba(139,104,70,0.33)';
export const border = '1px solid #D7D7D7';
